import React from 'react';
import './AppContainer.css'
import AppHeader from "./AppHeader";
import AppIntroduction from "./AppIntroduction";
import AppAbout from "./AppAbout";
import AppServices from "./AppServices";
import AppPortfolio from "./AppPortfolio";
// import AppApply from "./AppApply";
import AppContact from "./AppContact";
import AppAlert from "./AppAlert";

const {$, App, LoginForm, ContactForm, OwlCarousel, StyleSwitcher, RevolutionSlider} = window;

class AppContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            projects: [
                {
                    title: "Djamma Taxi",
                    html: "assets/ajax/djamma-taxi.html",
                    image: "assets/img/portfolio/djamma-taxi.svg",
                    client: "assets/img/portfolio/djamma-taxi.svg",
                    link: "https://taxi.djammadev.com",
                    description: "Gestion des flottes de moto taxi avec suivi des paiements"
                },
                {
                    title: "Shini Pay",
                    html: "assets/ajax/shini-pay.html",
                    image: "assets/img/portfolio/shini-pay.svg",
                    client: "assets/img/portfolio/shini-pay.png",
                    link: "https://shinipay.djammadev.com/",
                    description: "Application mobile pour systèmes de paiement dans les cantines"
                },
                {
                    title: "Servair",
                    html: "assets/ajax/servair.html",
                    image: "assets/img/portfolio/servair.svg",
                    client: "assets/img/portfolio/servair.png",
                    link: "https://servair.shinitech.com/",
                    description: "Gestion de cantine"
                },
                {
                    title: "i151",
                    html: "assets/ajax/i151.html",
                    image: "assets/img/portfolio/i151.svg",
                    client: "assets/img/portfolio/i151.png",
                    link: "https://i151.djammadev.com",
                    description: "Jeu de cartes"
                },
                {
                    title: "Djamma Payment",
                    html: "assets/ajax/djamma-payment.html",
                    image: "assets/img/portfolio/djamma-payment.svg",
                    client: "assets/img/portfolio/djamma-payment.png",
                    link: "https://checkout.djammadev.com/",
                    description: "Système de paiement mobile"
                },
                {
                    title: "Demebaga",
                    html: "assets/ajax/demebaga.html",
                    image: "assets/img/portfolio/demebaga.svg",
                    client: "assets/img/portfolio/demebaga.png",
                    link: "https://demeden.djammadev.com/",
                    description: "Assistant IA pour organiser les transactions financières"
                },
                {
                    title: "Chiesulu",
                    html: "assets/ajax/chiesulu.html",
                    image: "assets/img/portfolio/chiesulu.svg",
                    client: "assets/img/portfolio/chiesulu.png",
                    link: "https://chiesulu.djammadev.com/",
                    description: "Application de gestion de poulailler"
                },
                {
                    title: "Chiesugu",
                    html: "assets/ajax/chiesugu.html",
                    image: "assets/img/portfolio/chiesugu.svg",
                    client: "assets/img/portfolio/chiesugu.png",
                    link: "https://chiesugu.djammadev.com/",
                    description: "Place de marché pour les ventes des volailles"
                },
                {
                    title: "Kalan",
                    html: "assets/ajax/kalan.html",
                    image: "assets/img/portfolio/kalan.svg",
                    client: "assets/img/portfolio/kalan.png",
                    link: "https://kalan.djammadev.com/",
                    description: "Application pour recrutement des enseignants volontaires"
                }
            ]
        };
    }

    render() {
        return (
            <>
                <AppHeader/>
                <AppAlert/>
                <section id="intro" className="intro-section">
                    <AppIntroduction/>
                </section>
                <section id="about" className="about-section section-first">
                    <AppAbout/>
                </section>
                <section id="services">
                    <AppServices/>
                </section>
                <section id="portfolio">
                    <AppPortfolio projects={this.state.projects}/>
                </section>
                {/*<section id="apply" className="apply-section">
                    <AppApply/>
                </section>*/}
                <section id="contact" className="contacts-section">
                    <AppContact/>
                </section>
                <section id="copyright">
                    <div className="copyright-section">
                        <p>{new Date().getFullYear()} &copy; All Rights Reserved. <span
                            className="djamma-dev"><span>Djamma</span> Dev Mali</span></p>
                        <ul className="social-icons">
                            <li>
                                <a target="_blank" rel="noopener noreferrer"
                                   href="https://www.facebook.com/Djamma-Dev-281565102794793/"
                                   data-original-title="Facebook" className="social_facebook rounded-x"><i/></a>
                            </li>
                            <li><a target="_blank" rel="noopener noreferrer"
                                   href="https://twitter.com/Mcicheick"
                                   data-original-title="Twitter"
                                   className="social_twitter rounded-x"><i/></a>
                            </li>
                            <li>
                                <a href="/#" rel="noopener noreferrer" data-original-title="Goole Plus"
                                   className="social_googleplus rounded-x"><i/></a>
                            </li>
                            <li>
                                <a href="/#" rel="noopener noreferrer" data-original-title="Pinterest"
                                   className="social_pintrest rounded-x"><i/></a>
                            </li>
                            <li>
                                <a href="/#" rel="noopener noreferrer" data-original-title="Linkedin"
                                   className="social_linkedin rounded-x"><i/></a>
                            </li>
                        </ul>
                        <span className="page-scroll">
                            <a href="#intro"><i
                                className="fa fa-angle-double-up back-to-top"/></a>
                        </span>
                    </div>
                </section>
            </>
        );
    }

    componentDidMount() {
        $(document).ready(function () {
            App.init();
            App.initCounter();
            App.initParallaxBg();
            LoginForm.initLoginForm();
            ContactForm.initContactForm();
            OwlCarousel.initOwlCarousel();
            StyleSwitcher.initStyleSwitcher();
            RevolutionSlider.initRSfullScreen();
        });
    }
}

export default AppContainer;